module.exports = __webpack_public_path__ + "static/media/monitor_company.9047929d.svg";